import { css } from '@emotion/react';
import { FC } from 'react';

export const TOOLTIP_ARROW_CLASSNAME = '__mapui_tooltip_arrow';

const applyMainStyles = () => (theme: any) => {
  const arrow = css(theme.tooltip.arrow);
  const defaultStyle = css(theme.tooltip.defaultStyles);

  const styles = [arrow, defaultStyle];

  return css(...styles);
};

export const TooltipArrow: FC = () => (
  <div className={TOOLTIP_ARROW_CLASSNAME} css={applyMainStyles()} />
);
